import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import {
	BasicSelect
} from 'vue-search-select';
import {
	Validator
} from 'vee-validate'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import user_tracker from '../../../../usertracker'
import utils from "../../../../utils/validateScanner"

export default {
	name: 'inscan-overage-shipment',
	mixins: [utils],
	components: {
		VueElementLoading,
		BasicSelect,
		Paginate,
		DatePicker
	},
	props: [],
	data() {
		return {
			isLoading: false,
			hubLoading: '',
			opened: [],
			OverageShipmentList: [],
			OverageBagList: [],
			OverageShipmentDetailsList: [],
			hublist: [],
			hubitem: {
				value: '',
				text: ''
			},
			hub: '',
			checkedType: '',
			shippingID: '',
			shippingIDError: '',
			checkedTypeError: '',
			reason: '',
			reasonError: '',
			hubid: '',
			hubName: '',
			createdbyemail: '',
			pageNo: 0,
			limit: 10,
			pageCount: 0,
			totalRows: 0,
			token: '',
			invalidTokenModal: false,
			invalidtokenmsg: '',
			timeoutHandler: 0,
			inputString:'',
			manualInput:false,
			userData:[],
			fromdate: '',
      		todate: '',
			addmodalShow: false,
			todaysDate: new Date(),
			isallowoverageApprovalFlag: false,
			isblock : false,
			shipmentForColor : ''
		}
	},
	computed: {},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		},
	},
	mounted() {
		var userTokenEncrypt = window.localStorage.getItem('userToken')
		var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
		var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
		this.token = JSON.parse(userToken)
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.userData = userdetail;
		this.hubid = userdetail[0].HubId[0];
		this.createdbyemail = userdetail[0].email;
		this.getLoginHubName(userdetail[0].HubId)
		this.getHubList();
		this.getHubDetailslist(userdetail[0].HubId);
	},
	methods: {
		checkBarcode(e){
			if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler)
      this.inputString += String.fromCharCode(e.keyCode)
    	}
			this.timeoutHandler = setTimeout(() => {
		 		if (this.inputString.length <= 3) {
			 		this.manualInput = true
			 		this.inputString = ''
		 		}else{
			 		this.manualInput = false
			 		this.inputString = ''
		 		}
	 		}, 10)
 		},
		 getHubDetailslist(hubid) {
			this.hubLoading = true
			axios({
				method: 'GET',
				'url': apiUrl.api_url_hubops + 'fetchHubTempInscanRestrict?hubid=' + this.hubid,
				'data': {},
				headers: {
				  'authorization': 'authkey xB84JJ89Hd25',
				}
			  })
			  .then(result => {
				this.hubLoading = false
				if (result.data.ResultCode == 100) {
				  this.isallowoverageApprovalFlag = result.data.ResponseData[0].isoverageapprovalflag;
			}
			   else {
				  this.isallowoverageApprovalFlag=false;
				}
			  }, error => {
				this.hubLoading = false
				console.error(error)
			  })
		  },
		getLoginHubName(hubid) {
			this.input = {
				hubids: hubid
			}
			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.hubName = result.data.ResponseData[0].HubName;
					} else {
						this.hubName = '';
					}
				}, error => {
					console.error(error)
				})
		},
		getHubList() {
			this.hubLoading = 'Loading Hub...'
			this.input = ({})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/dropdwon/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubLoading = ''
					var HubDetails = result.data.ResponseData
					for (var i = 0; i < HubDetails.length; i++) {
						this.hublist.push({
							"value": HubDetails[i].HubID,
							"text": HubDetails[i].HubName + '(' + HubDetails[i].HubID + ')',
						})
					}
					this.hubitem = {
						value: this.hubid,
						text: this.hubName
					}
					this.hub = this.hubitem.text
				}, error => {
					console.error(error)
				})
		},
		logout(e) {
			localStorage.removeItem('permissiondata')
			localStorage.removeItem('userdetail')
			localStorage.removeItem('userToken')
			localStorage.removeItem('isLoggedIn')
			localStorage.removeItem('loginDate')
			this.$router.push('/login')
			e.preventDefault()
		},
		closeinvalidTokenModal() {
			this.invalidTokenModal = false
			this.invalidtokenmsg = ''
		},
		calculateMaxToDate(fromDate) {
			const maxDate = new Date(fromDate);
			maxDate.setDate(maxDate.getDate() + 180);

			const today = new Date();
			if (maxDate > today) {
			  return today;
			} else {
			  return maxDate;
			}
		},
		showOverageDetails() {
			if (this.checkedType == '') {
				this.checkedTypeError = "Select Type"
				return false;
			} else if (this.hub == "") {
				return false;
			} else {
				this.checkedTypeError = ""
				this.isLoading = true
				this.totalRows = 0
				this.input = {
					"hubId": this.hubitem.value,
					"pageIndex": this.pageNo,
					"pageSize": this.limit
				}
				if (this.checkedType == 'shipment') {
					this.input["FromDate"] = this.fromdate;
					this.input["ToDate"] = this.todate;
					axios({
							method: 'POST',
							url: apiUrl.api_url_hubops + 'overageShipmentDetailsPendingList',
							data: this.input,
							headers: {
								'authorization': 'authkey xB84JJ89Hd25',
								'requestfrom': "WEB",
								'token': this.token
							}
						})
						.then((response) => {
							this.isLoading = false
							if (response.data.ResultCode == 100) {
								this.invalidTokenModal = false
								this.OverageShipmentList = response.data.ResponseData
								this.totalRows = response.data.TotalCount
								if (this.totalRows < 10) {
									this.pageCount = 1
								} else {
									this.pageCount = Math.ceil(this.totalRows / 10);
								}
							} else if (response.data.ResultCode == 401) {
								this.invalidTokenModal = true
								this.invalidtokenmsg = result.data.ReturnMessage
								this.OverageShipmentList = [];
								this.$alertify.error(result.data.ReturnMessage)
							} else {
								this.invalidTokenModal = false
								this.OverageShipmentList = [];
								this.$alertify.error(response.data.ReturnMessage)
							}
						})
						.catch((httpException) => {
							this.isLoading = false
							console.error('exception is:::::::::', httpException)
						})
				} else {
					axios({
							method: 'POST',
							url: apiUrl.api_url_hubops + 'overageBagDetailsPendingList',
							data: this.input,
							headers: {
								'authorization': 'authkey xB84JJ89Hd25',
								'requestfrom': "WEB",
								'token': this.token
							}
						})
						.then((response) => {
							this.isLoading = false
							if (response.data.ResultCode == 100) {
								this.invalidTokenModal = false
								this.totalRows = response.data.TotalCount
								this.OverageBagList = response.data.ResponseData
								if (this.totalRows < 10) {
									this.pageCount = 1
								} else {
									this.pageCount = Math.ceil(this.totalRows / 10);
								}
							} else if (response.data.ResultCode == 401) {
								this.invalidTokenModal = true
								this.invalidtokenmsg = result.data.ReturnMessage
								this.$alertify.error(result.data.ReturnMessage)
							} else {
								this.invalidTokenModal = false
								this.$alertify.error(response.data.ReturnMessage)
							}
						})
						.catch((httpException) => {
							this.isLoading = false
							console.error('exception is:::::::::', httpException)
						})
				}
			}
		},
		getPaginationData(pageNum) {
			this.pageNo = (pageNum - 1)
			this.showOverageDetails()
		},
		getShipmentOverageList(data, ind) {
			const index = this.opened.indexOf(ind);
			if (index > -1) {
				this.opened.splice(index, 1)
			} else {
				this.opened = [];
				this.opened.push(ind)
				this.OverageShipmentDetailsList = []
				this.input = {
					"shippingId": data.shippingid
				}
				axios({
						method: 'POST',
						url: apiUrl.api_url_hubops + 'overageShipmentDetailsByShippingId',
						data: this.input,
						headers: {
							'authorization': 'authkey xB84JJ89Hd25',
							'requestfrom': "WEB",
							'token': this.token
						}
					})
					.then((response) => {
						if (response.data.ResultCode == 100) {
							this.invalidTokenModal = false
							this.OverageShipmentDetailsList = response.data.ResponseData.result
							// this.$alertify.success(response.data.ReturnMessage)
						} else if (response.data.ResultCode == 401) {
							this.invalidTokenModal = true
							this.invalidtokenmsg = result.data.ReturnMessage
							this.$alertify.error(result.data.ReturnMessage)
						} else {
							this.invalidTokenModal = false
							this.$alertify.error(response.data.ReturnMessage)
						}
					})
					.catch((httpException) => {
						console.error('exception is:::::::::', httpException)
					})
			}
			// if(this.shippingID==''){
			//   this.shippingIDError="The shipping ID field is required."
			//   return false;
			// }
			// else{this.shippingIDError=""}
		},
		inscanShipment() {
			if(this.shippingID == '') {
				this.manualInput = false;
				this.shippingIDError = "The shipping ID field is required."
				return false;
			} else {
				this.addmodalShow = true;
			}
		},
		closeStatusModal() {
			this.addmodalShow = false
		},
		searchShipmentID() {
			if(this.shippingID == '') {
				this.manualInput = false;
				this.shippingIDError = "The shipping ID field is required."
				return false;
			}
			this.OverageShipmentList = [];
			this.shippingIDError = "";
			this.totalRows = 0;
			this.pageNo = 0
			this.isblock = false; 
			this.input = {
				"hubId": this.hubid,
				"pageIndex": this.pageNo,
				"pageSize": this.limit,
				"shippingId": this.shippingID
			}
			this.isLoading = true;
			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'overageShipmentDetailsPendingList',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
						'requestfrom': "WEB",
						'token': this.token
					}
			})
			.then((response) => {
				this.isLoading = false;
				if (response.data.ResultCode == 100) {
					this.invalidTokenModal = false
					this.OverageShipmentList = response.data.ResponseData
					this.totalRows = response.data.TotalCount
					if(Object.keys(response.data.lossCategorization).length !=0){
						this.colorCode = response.data.lossCategorization.colorCode;
              			this.colorIcon = response.data.lossCategorization.icon;
					}
				} else if (response.data.ResultCode == 401) {
					this.invalidTokenModal = true
					this.showHideCodeIconInput();
					this.invalidtokenmsg = result.data.ReturnMessage
					this.$alertify.error(result.data.ReturnMessage)
				} else {
					this.invalidTokenModal = false
					this.showHideCodeIconInput();
					this.$alertify.error(response.data.ReturnMessage)
				}
			})
			.catch((httpException) => {
				this.isLoading = false
				this.showHideCodeIconInput();
				console.error('exception is:::::::::', httpException)
			})
		},
		UpdateShipmentOverage() {
			if (this.shippingID == '') {
				this.manualInput = false
				this.shippingIDError = "The shipping ID field is required."
				return false;
			} else {
				this.isblock = true; 
				this.shippingIDError = ""
				this.input = {
					"overageShipmentDetailsId": 0, //optional
					"hubId": this.hubid,
					"hubName": this.hubName,
					"shippingId": this.shippingID,
					"comments": "", //optional
					"lastModifiedBy": this.createdbyemail,
					"isShipment": this.checkedType == 'shipment' ? true : false,
					"status": true,
					"isManualEntry": this.manualInput
				}
				axios({
						method: 'POST',
						url: apiUrl.api_url_hubops + 'overageBagOrShipmentUpdate',
						data: this.input,
						headers: {
							'authorization': 'authkey xB84JJ89Hd25',
							'requestfrom': "WEB",
							'token': this.token
						}
					})
					.then((response) => {
						if (response.data.ResultCode == 100) {
							this.invalidTokenModal = false
							if(Object.keys(response.data.lossCategorization).length !=0){
              				this.shipmentForColor = this.shippingID
							this.showHideCodeIconInput(response.data.lossCategorization.colorCode, response.data.lossCategorization.icon);
						}
							this.$alertify.success(response.data.ReturnMessage)
						} else if (response.data.ResultCode == 401) {
							this.invalidTokenModal = true
							this.invalidtokenmsg = result.data.ReturnMessage
							this.$alertify.error(result.data.ReturnMessage)
						} else {
							this.invalidTokenModal = false
							this.$alertify.error(response.data.ReturnMessage)
						}
							user_tracker.checkUserIP(this.userData[0], "BagOut_InscanOverage", this.$route.path,this.input);
					})
					.catch((httpException) => {
						console.error('exception is:::::::::', httpException)
					})
			}
		},
		InscanShipmentOverage(OverageShipmentDetailsList) {
			this.input = {
				"overageShipmentDetailsId": 0, //optional
				"hubId": this.hubid,
				"hubName": this.hubName,
				"shippingId": OverageShipmentDetailsList.shippingid,
				"comments": OverageShipmentDetailsList.reason, //optional
				"lastModifiedBy": this.createdbyemail,
				"isShipment": this.checkedType == 'shipment' ? true : false,
				"status": false,
				"isManualEntry": false
			}
			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'overageBagOrShipmentUpdate',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
						'requestfrom': "WEB",
						'token': this.token
					}
				})
				.then((response) => {
					if (response.data.ResultCode == 100) {
						this.invalidTokenModal = false
						this.$alertify.success(response.data.ReturnMessage)
						this.showOverageDetails()
					} else if (response.data.ResultCode == 401) {
						this.invalidTokenModal = true
						this.invalidtokenmsg = result.data.ReturnMessage
						this.$alertify.error(result.data.ReturnMessage)
					} else {
						this.invalidTokenModal = false
						this.$alertify.error(response.data.ReturnMessage)
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		InscanBagOverage(data) {
			this.input = {
				"overageShipmentDetailsId": data.overageshipmentdetailsid, //optional
				"hubId": this.hubid,
				"hubName": this.hubName,
				"shippingId": data.bagno,
				"comments": data.reason, //optional
				"lastModifiedBy": this.createdbyemail,
				"isShipment": this.checkedType == 'shipment' ? true : false,
				"status": false,
				"isManualEntry": false
			}
			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'overageBagOrShipmentUpdate',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
						'requestfrom': "WEB",
						'token': this.token
					}
				})
				.then((response) => {
					if (response.data.ResultCode == 100) {
						this.invalidTokenModal = false
						this.$alertify.success(response.data.ReturnMessage)
						this.showOverageDetails()
					} else if (response.data.ResultCode == 401) {
						this.invalidTokenModal = true
						this.invalidtokenmsg = result.data.ReturnMessage
						this.$alertify.error(result.data.ReturnMessage)
					} else {
						this.invalidTokenModal = false
						this.$alertify.error(response.data.ReturnMessage)
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		resetForm() {
			//this.hub = ''
			// this.hubitem = {
			//   value: '',
			//   text: ''
			// }
			this.checkedType = ''
			this.checkedTypeError = ''
			this.opened = []
			this.OverageBagList = []
			this.OverageShipmentList = []
			this.OverageShipmentDetailsList = []
			this.isLoading = false
			this.$validator.reset()
			this.fromdate = ''
			this.todate = ''
			this.pageNo = 0
			this.showHideCodeIconInput();
			this.shipmentForColor =''
		},
		clearID() {
			this.shippingID = ''
			this.manualInput = false
			this.shippingIDError = ''
			this.opened = []
			this.OverageBagList = []
			this.OverageShipmentList = []
			this.OverageShipmentDetailsList = []
			this.fromdate = ''
			this.todate = ''
			this.pageNo = 0
			this.isLoading = false
			if (this.checkedType == '') {
				this.checkedTypeError = "Select Type"
			} else {
				this.checkedTypeError = ""
			}
		},
		selectReason(reasonitem) {
			this.reasonitem = reasonitem
			this.reason = this.reasonitem.text
		},
		clearError() {
			if (this.shippingID == '') {
				this.manualInput = false
				this.shippingIDError = "The shipping ID field is required."
			} else {
				this.shippingIDError = ""
			}
		},
		closeList(){
			this.opened = []
		},
		onSubmit: function(event) {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				}
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},
		onSubmitShipment: function(event) {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				}
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/InscanOverageShortage/InscanOverageShipment/InscanOverageShipment.js